export default {"src":"/_next/static/media/_guides.4dc73305.svg","height":24,"width":24};